import { render, staticRenderFns } from "./notification-dropdown.vue?vue&type=template&id=78a00303&"
import script from "./notification-dropdown.vue?vue&type=script&lang=ts&"
export * from "./notification-dropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports